<app-page [simpleTopBar]="true" [showBottomBar]="false" [title]="title">
  <transfer-nft [post]="post" [postHashHex]="postHashHex" (changeTitle)="title = $event"></transfer-nft>
</app-page>
